import { render, staticRenderFns } from "./MultiselectDropdownItems.vue?vue&type=template&id=64791ffa&scoped=true&"
import script from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDropdownItems.vue?vue&type=style&index=0&id=64791ffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64791ffa",
  null
  
)

export default component.exports